/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 public/assets-by-page/about/models/taxi_with_ad_reduced.glb --transform --shadows
*/
import { useGLTF } from '@react-three/drei'
import { editable } from '@theatre/r3f'

export default function TaxiReduced() {
	const { nodes, materials } = useGLTF(process.env.PUBLIC_URL + '/assets-by-page/about/models/taxi_with_ad_reduced-transformed.glb')
	return (
		<editable.group theatreKey='Taxi' scale={25} rotation={[0, Math.PI / 2, 0]}>
			<mesh castShadow geometry={nodes.defaultMaterial004.geometry} material={materials.TaxiCar01Glass} />
			<mesh castShadow geometry={nodes.defaultMaterial005.geometry} material={materials.TaxiCar01}>
				<mesh
					castShadow
					geometry={nodes.BurgerBillboard.geometry}
					material={materials.BurgerBillboard}
					position={[-0.05, 0.28, -0.14]}
					rotation={[Math.PI / 2, -0.32, Math.PI / 2]}
					scale={0.13}
				/>
			</mesh>
			<mesh castShadow geometry={nodes.defaultMaterial002.geometry} material={materials.TaxiCar01} />
			<mesh castShadow geometry={nodes.defaultMaterial.geometry} material={materials.TaxiCar01} position={[-0.3, -0.2, -0.48]} />
			<mesh castShadow geometry={nodes.defaultMaterial003.geometry} material={materials.TaxiCar01} />
			<editable.mesh
				theatreKey='front-wheel'
				geometry={nodes.defaultMaterial001.geometry}
				material={materials.TaxiCar01}
				position={[-0.3, -0.2, 0.61]}
				castShadow
				receiveShadow
			/>
		</editable.group>
	)
}
